import { createContext, useContext } from "react";
import type { RouteObject } from "react-router";

export interface RouteTreeContextValue {
	routeObjects: RouteObject[];
	gatedFeatureSegments: ReadonlySet<string>;
}

// WHY: avoids reintroducing the import cycle scopedFeaturePaths.ts used to have with router.tsx.
const RouteTreeContext = createContext<RouteTreeContextValue | null>(null);

export const RouteTreeProvider = RouteTreeContext.Provider;

export const useRouteTree = (): RouteTreeContextValue => {
	const value = useContext(RouteTreeContext);
	if (!value) {
		throw new Error("useRouteTree must be used within a RouteTreeProvider");
	}
	return value;
};
